const questionTypes = {
    YES_NO: 'YES_NO',
    TEXT: 'TEXT',
    SINGLE_CHOICE: 'SINGLE_CHOICE',
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
};

export default questionTypes;
